mutation DeleteEmailSequence($payload: EmailSequenceDeleteInput!) {
    emailSequenceDelete(input: $payload) {
        emailSequence {
            id
        }
    }
}
